export default "__VITE_ASSET__DbleLXpi__"